import React from 'react'
import { useTheme } from '@/components/ThemeProvider'

const MoneyBackGuarantee = ({ version }: { version?: string }) => {
  const { theme } = useTheme()
  return version ? (
    <section className="relative">
      <div className=" relative text-center text-white bg-[#FBFBFBA3] border border-[#A9B2FF] dark:border-none dark:bg-transparent dark:bg-grayGradient mx-auto flex flex-col gap-4 p-4 mt-8 mb-8 rounded-4xl ">
        <h3 className="text-center text-LXL2 leading-[26px] font-semibold">Money-Back Guarantee</h3>
        <p className="text-[11px] leading-[1.35] text-[#A1A1A1] dark:text-[#C3C3C4]">
          We are confident in the quality of our app – tens of thousands of users around the world
          have already optimized their photo storage with the Clean Master app. We are prepared to
          refund your money if you encountered technical issues that hindered the proper use of the
          application.
        </p>
      </div>
      <div className="absolute dark:top-1/2 -top-10 left-1/2 -translate-x-1/2 -translate-y-1/2 dark:w-[400px] w-[430px] z-[-1]">
        <img
          className="w-full"
          src={`${theme === 'dark' ? '/img/email/circle-3.svg' : '/img/email/circle-light.svg'}`}
          alt="vector"
        />
      </div>
    </section>
  ) : (
    <section
      className="max-w-[375px] mx-auto z-10 flex flex-col gap-4 p-6 mt-8 mb-6 rounded-4xl bg-white15 dark:bg-white20 bg-no-repeat bg-moneyBackGuarantee bg-[right_12px_bottom_12px]"
      style={{ backgroundSize: '75px' }}
    >
      <h3 className="text-center text-LXL2 leading-[26px] font-bold">Money-Back Guarantee</h3>
      <p className="text-S leading-4">
        We are confident in the quality of our app – tens of thousands of users around the world
        have already optimized their photo storage with the Clean Master app. We are prepared to
        refund your money if you encountered technical issues that hindered the proper use of the
        application.
      </p>
    </section>
  )
}

export default MoneyBackGuarantee
